import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { WaybillIdView } from '../../../../models';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { ShipmentWaybillStatusHistoryState } from './shipment-waybill-status-history.state';
import { Observable } from 'rxjs';
import {
  ShipmentWaybillStatusHistoryMainInfo,
  ShipmentWaybillStatusHistoryStatuses,
} from '../../models/shipment-waybill-status-history.model';
import {
  ShipmentWaybillStatusHistoryLoad,
  ShipmentWaybillStatusHistorySetInitialState,
} from './shipment-waybill-status-history.actions';

@Injectable({ providedIn: 'root' })
export class ShipmentWaybillStatusHistoryFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(ShipmentWaybillStatusHistoryState.getLoaded);
  mainInfo$: Observable<ShipmentWaybillStatusHistoryMainInfo> = this.store.select(
    ShipmentWaybillStatusHistoryState.getStatusHistoryMainInfo,
  );
  statusHistory$: Observable<ShipmentWaybillStatusHistoryStatuses> = this.store.select(
    ShipmentWaybillStatusHistoryState.getStatusHistoryView,
  );

  constructor(private store: Store) {}

  loadAll(identifier: WaybillIdView): void {
    this.store.dispatch(new ShipmentWaybillStatusHistoryLoad(identifier));
  }

  setInitialState(): void {
    this.store.dispatch(new ShipmentWaybillStatusHistorySetInitialState());
  }
}
